export const parseLayoutData = (layout) => {
    let finalLayout = []
    finalLayout = layout.map((row) => {
        return {
            ...row,
            columns: row.columns.map((column) => {
                if (column.type !== "separator")
                    return {
                        ...column,
                        widgets: column.widgets.map((widget) => {
                            return {
                                ...widget,
                                parsedData: parseWidgetData(widget),
                            }
                        }),
                    }
                else {
                    return {
                        ...column,
                    }
                }
            }),
        }
    })

    return finalLayout
}

export const parseWidgetData = (widget) => {
    const { type } = widget

    let parsedWidgetData = {}

    switch (type) {
        case "separator":
            return null

        case "filters":
            parsedWidgetData.filters = []

            widget.data?.values.forEach((filterData) => {
                const parsedFilterData = {
                    value: filterData.key,
                    count: filterData.count,
                    name: filterData.name,
                    displayText: filterData.label,
                    hasSearch: filterData.has_search,
                    isMultiChoice: filterData.is_multi_choice,
                }

                let parsedValues = []
                filterData.values.forEach((value) => {
                    parsedValues.push({
                        value: value.key,
                        displayText: value.name,
                        selected: value.selected,
                        count: value.count,
                    })
                })

                parsedFilterData.values = parsedValues

                parsedWidgetData.filters.push(parsedFilterData)
            })

            return parsedWidgetData

        case "heading_with_dropdown":
            parsedWidgetData.items = []
            widget.data?.values.forEach((item) => {
                parsedWidgetData.items.push({
                    label: item.name,
                    value: item.key,
                })
            })

            parsedWidgetData.header = widget.data.heading

            return parsedWidgetData

        case "lab_listing":
            parsedWidgetData.labs = widget.items.map(
                ({
                    image,
                    rating,
                    price,
                    slot_string,
                    sales,
                    disclaimer,
                    tat,
                    price_more_info,
                    primary_cta,
                    ...item
                }) => {
                    return {
                        ...item,
                        image: {
                            url: image?.url,
                            alt: image?.alt,
                        },
                        rating: {
                            averageRating: rating?.average_rating,
                            totalRatings: rating?.total_ratings,
                        },
                        price: {
                            mrp: price?.mrp,
                            discount: price?.discount,
                            discountedPrice: price?.discounted_price,
                            suffix: price?.price_suffix,
                        },
                        sales: {
                            displayText: sales?.display_text,
                            validity: sales?.validity,
                        },
                        disclaimer: {
                            backgroundColor: disclaimer?.background_color,
                            description: disclaimer?.description,
                            iconUrl: disclaimer?.icon_url,
                        },
                        slotString: slot_string,
                        reportTat: tat,
                        priceInfoLabel: price_more_info?.heading,
                        ctaLabel: primary_cta?.text,
                        priceInfo: parsePriceInfo(price_more_info || {}),
                        priceInfoHandler: null,
                        mixPanelData: item.mix_panel_data,
                    }
                }
            )

            return parsedWidgetData

        case "test_suggestion":
            parsedWidgetData = {}
            parsedWidgetData.header = widget.data?.header
            parsedWidgetData.mixPanelData = widget.data?.mix_panel_data
            parsedWidgetData.suggestions = []

            widget.data?.category_suggestion?.forEach((suggestion) => {
                const parsedSuggestion = {
                    name: suggestion.name,
                    image: suggestion.image,
                    tests: suggestion.tests,
                }

                parsedWidgetData.suggestions.push(parsedSuggestion)
            })

            return parsedWidgetData

        case "test_information":
            parsedWidgetData = {
                header: widget.data?.header,
                testPrecautions: widget.data?.test_precautions?.descriptions,
                testDetails: widget.data?.test_details?.map((detail) => {
                    return {
                        id: detail.id,
                        name: detail.name,
                        description: detail.description,
                    }
                }),
            }

            return parsedWidgetData

        case "popular_tests":
            parsedWidgetData = {
                header: widget.data?.header,
                popularTests: widget.data?.popular_tests?.map((test) => {
                    return {
                        id: test.id,
                        name: test.name,
                        category: test.category,
                        mixPanelData: test.mix_panel_data,
                    }
                }),
                mixPanelData: widget.data?.mix_panel_data,
            }

            return parsedWidgetData

        default:
            return undefined
    }
}

const parsePriceInfo = ({ test_details = [], discount = {}, total_amount } = {}) => {
    const parsedPriceInfo = {
        discount: {
            couponLabel: discount?.coupon_string,
            couponAmount: discount?.coupon_amount,
            discountLabel: discount?.discount_string,
            discountedAmount: discount?.discounted_amount,
        },
        totalLabel: "Total Amount",
        totalAmount: total_amount,
    }

    parsedPriceInfo.testDetails = test_details.map(({ name, price, tat }) => ({
        name,
        price,
        tatLabel: tat ? `${tat.text} ${tat.value}` : null,
    }))

    return parsedPriceInfo
}

export const addLabTestErrorParser = (error) => {
    const dialogData = {
        imageUrl: error?.dialog_data?.data?.icon,
        imageDimensions: {
            height: "48px",
            width: "48px",
        },
        heading: error?.dialog_data?.data?.header,
        subHeading: error?.dialog_data?.data?.description,
        primaryCtaLabel: error?.dialog_data?.data?.confirm_cta?.text,
        secondaryCtaLabel: error?.dialog_data?.data?.cancel_cta?.text,
    }

    return dialogData
}

export const parseGALabel = (lab, position, sku_ids, lab_select_type) => {
    const label = {
        lab_id: lab?.id,
        lab_name: lab?.name,
        position,
        sku_ids,
        lab_select_type,
    }
    return label
}
